var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDash1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2671 0.810351C22.1866 -0.270117 20.4401 -0.270117 19.3596 0.810351L18.1558 2.01416L22.9858 6.8442L24.1896 5.64039C25.2701 4.55992 25.2701 2.81341 24.1896 1.73294L23.2671 0.810351ZM8.5056 11.6644C8.20465 11.9653 7.97277 12.3353 7.83956 12.7448L6.3792 17.1259C6.23612 17.5502 6.3496 18.0189 6.66535 18.3396C6.9811 18.6603 7.4498 18.7688 7.87903 18.6257L12.2601 17.1654C12.6647 17.0322 13.0347 16.8003 13.3406 16.4993L21.3133 8.5167L16.4833 3.68666L8.5056 11.6644ZM4.7363 2.89728C2.12147 2.89728 0 5.01875 0 7.63358V20.2637C0 22.8785 2.12147 25 4.7363 25H17.3664C19.9813 25 22.1027 22.8785 22.1027 20.2637V15.5274C22.1027 14.6542 21.3972 13.9486 20.524 13.9486C19.6507 13.9486 18.9452 14.6542 18.9452 15.5274V20.2637C18.9452 21.137 18.2397 21.8425 17.3664 21.8425H4.7363C3.86304 21.8425 3.15753 21.137 3.15753 20.2637V7.63358C3.15753 6.76032 3.86304 6.05481 4.7363 6.05481H9.47259C10.3458 6.05481 11.0514 5.3493 11.0514 4.47605C11.0514 3.60279 10.3458 2.89728 9.47259 2.89728H4.7363Z",
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash1);
export default __webpack_public_path__ + "static/media/dash1.f46264bc5b6d83e38b5a4cdf6be9e863.svg";
export { ForwardRef as ReactComponent };